define('components/sidemenu/models/SideMenuModel', [

], function() {

    var SideMenuModel = Backbone.Model.extend({
        defaults: {
            viewId: "someId",               // Classic default viewId
            view: null,                     // View to display into menu
            attach: "body",                 // Selector $ to attach menu
            opened: false,                  // Private
            position: "left",               // Set position of the menu ( left || right )
            width: "350px",                 // Width of the menu
            openCallback: null,             // Callback when open menu
            closeCallback: null             // Callback when close menu
        }
    });

    return SideMenuModel;
});
